import { createAction } from 'redux-actions';
import { PapiBadge, PapiComment, PapiDeviation } from '@wix/da-papi-types';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
import { reduxKey } from './constants';
import {
  CoreBadgeType,
  CoreBadgeRecipient,
  AwardBadgeSource,
  AwardableBadge,
  GemRestrictions,
} from '../types';
import { ResourceType } from '../../types/resource';
import { getRecipientForComment, getRecipientForDeviation } from '../utils';

export const pushAwardBadgeModal = (
  recipient: CoreBadgeRecipient,
  source: AwardBadgeSource,
  typeId: ResourceType,
  itemId: number,
  sectionname?: string
) =>
  pushModal(ModalType.AWARD_BADGE, {
    params: { recipient, source, typeId, itemId, sectionname },
    wrapInModal: false,
    biContext: sectionname
      ? {
          sectionname,
        }
      : undefined,
  });

export const beginDeviationAwardBadgeFlow = (
  deviation: PapiDeviation,
  source: AwardBadgeSource,
  sectionname: string = 'deviation'
) =>
  pushAwardBadgeModal(
    getRecipientForDeviation(deviation),
    source,
    ResourceType.DEVIATION,
    deviation.deviationId,
    sectionname
  );

export const beginCommentAwardBadgeFlow = (
  comment: PapiComment,
  source: AwardBadgeSource,
  sectionname: string = 'comment'
) =>
  pushAwardBadgeModal(
    getRecipientForComment(comment),
    source,
    ResourceType.COMMENT,
    comment.commentId,
    sectionname
  );

export const awardBadge = createAction(
  `${reduxKey}/AWARD`,
  (
    badgeType: CoreBadgeType,
    recipient: CoreBadgeRecipient,
    source: AwardBadgeSource
  ) => ({
    badgeType,
    recipient,
    source,
  })
);

export const awardingBadge = createAction(`${reduxKey}/AWARDING`, () => ({}));

// This action creator looks different because Redux actions are only
// typed out to four arguments; any more and we need to collapse the args
export const awardBadgeSuccess = createAction(
  `${reduxKey}/AWARD.SUCCESS`,
  (payload: {
    badge: PapiBadge;
    source: AwardBadgeSource;
    recipient: CoreBadgeRecipient;
    newBalance: number;
    allBadges: PapiBadge[];
  }) => payload
);

export const awardBadgeFail = createAction(
  `${reduxKey}/AWARD.FAIL`,
  (
    badgeType: CoreBadgeType,
    recipient: CoreBadgeRecipient,
    source: AwardBadgeSource,
    errorMsg: string
  ) => ({
    badgeType,
    recipient,
    source,
    errorMsg,
  })
);

export const fetchAvailableBadges = createAction(
  `${reduxKey}/FETCH_AVAILABLE_BADGES`,
  (userId: number, typeId?: ResourceType, itemId?: number) => ({
    userId,
    typeId,
    itemId,
  })
);

export const fetchAvailableBadgesSuccess = createAction(
  `${reduxKey}/FETCH_AVAILABLE_BADGES.SUCCESS`,
  (
    userId: number,
    results: AwardableBadge[],
    gemRestrictions: GemRestrictions
  ) => ({ userId, results, gemRestrictions })
);

export const fetchBadgeGiverStreamNext = createAction(
  `${reduxKey}/BADGE_GIVER_STREAM.FETCH_NEXT`,
  (streamId: string) => ({ streamId })
);
